import React from "react";
const TermsConditionsContent = () => {
    return (React.createElement("div", { className: "terms-content DMSan_14_500 txt_primaryGrey" },
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus.",
        React.createElement("br", null),
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, interdum tellus ut interdum tellus elit sed risus."));
};
export default TermsConditionsContent;
